import {Icon} from '@wandb/components';
import React from 'react';

type EventDescriptionSectionProps = {
  eventDescription: string;
};

export const EventDescriptionSection = ({
  eventDescription,
}: EventDescriptionSectionProps) => (
  <div className="flex items-center gap-16 px-12 py-8 border border-wb-border rounded-lg">
    <div className="p-10">
      <Icon icon="recent-clock" />
    </div>
    <div className="flex-1">
      <div className="font-semibold text-moon-500 dark:text-wb-text-tertiary">
        In the event that
      </div>
      <div className="text-moon-600 dark:text-wb-text-secondary break-all">
        {eventDescription}
      </div>
    </div>
  </div>
);
